export default __webpack_public_path__ + "static/media/star-silver.b9bd0794.svg";